/**
 * @generated SignedSource<<a5be05cca2ef4f1df5302d87c8f8eba9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AlimTalkTaskActivateInput = {
  id: string;
};
export type AlimTalkTaskId_alimTalkTaskActivateMutation$variables = {
  input: AlimTalkTaskActivateInput;
};
export type AlimTalkTaskId_alimTalkTaskActivateMutation$data = {
  readonly alimTalkTaskActivate: {
    readonly id: string;
  };
};
export type AlimTalkTaskId_alimTalkTaskActivateMutation = {
  response: AlimTalkTaskId_alimTalkTaskActivateMutation$data;
  variables: AlimTalkTaskId_alimTalkTaskActivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AlimTalkTask",
    "kind": "LinkedField",
    "name": "alimTalkTaskActivate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AlimTalkTaskId_alimTalkTaskActivateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AlimTalkTaskId_alimTalkTaskActivateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cd7814f54c37c1bc711b647756d3b854",
    "id": null,
    "metadata": {},
    "name": "AlimTalkTaskId_alimTalkTaskActivateMutation",
    "operationKind": "mutation",
    "text": "mutation AlimTalkTaskId_alimTalkTaskActivateMutation(\n  $input: AlimTalkTaskActivateInput!\n) {\n  alimTalkTaskActivate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9076e014cf4c88934e7b82ddaf761e1d";

export default node;
